export default __webpack_public_path__ + "static/electricity2-7f97782fe0ab7ef9401caa8660f15706.png";